/* eslint-disable no-case-declarations */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/react-in-jsx-scope */
import { Calendar, Tag, UserMinus } from '@saleshandy/icons';
import { useHistory, useLocation } from 'react-router';
import React from 'react';
import {
  FilterComponentType,
  LeadFinderSecondaryTab,
  SavedTabFilters,
} from '../../types';

let timeout: any;

export const FILTER_SAVED_LIST: any = [
  {
    id: 'filter-tag',
    key: 'tags',
    label: 'Tags',
    icon: <Tag />,
    type: [
      {
        id: 'filter-tag-checkboxes',
        key: 'tag',
        value: FilterComponentType.TAG_CHECKBOX,
        inputPlaceHolder: 'Select',
      },
    ],
  },
  {
    id: 'filter-date',
    key: 'createdDate',
    label: 'Date',
    icon: <Calendar />,
    type: [
      {
        id: 'filter-date',
        key: 'createdDate',
        value: FilterComponentType.SAVED_LEAD_DATE,
        inputPlaceHolder: 'Select',
      },
    ],
  },
  {
    id: 'filter-exclude-prospects',
    key: 'excludeProspects',
    label: 'Advance Filter',
    icon: <UserMinus />,
    peopleOnly: true,
    type: [
      {
        id: 'filter-exclude-prospects',
        key: 'excludeProspects',
        value: FilterComponentType.EXCLUDE_PROSPECTS,
        inputPlaceHolder: 'Select',
      },
    ],
  },
];

export const useSavedLeadFilter = () => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);

  const handleDefaultValues = (reset = false) => {
    const initialFilters: SavedTabFilters = {
      tags: [],
      createdDate: [],
      search: '',
      listIds: {
        includes: [],
        excludes: [],
      },
    };
    let filters: SavedTabFilters = initialFilters;
    if (reset) {
      return filters;
    }
    try {
      const searchValue = queryParams.get('search');
      filters.search = searchValue || '';
      if (queryParams.has('tags')) {
        const tags = queryParams
          .get('tags')
          ?.split(',')
          ?.map((ele) => parseInt(ele, 10));
        if (tags?.length) {
          filters.tags = tags;
        } else {
          filters.tags = [];
        }
      }
      if (queryParams.has('createdDate')) {
        const dateArr = queryParams.get('createdDate')?.split('-');
        if (dateArr && dateArr.length === 2) {
          const startDate = new Date(dateArr[0]);
          const endDate = new Date(dateArr[1]);
          filters.createdDate = [startDate, endDate];
        } else {
          filters.createdDate = [];
        }
      }
      // Extract list filters (both people and company) - comma-separated format
      const peopleListIncludesStr = queryParams.get('people_list');
      const peopleListExcludesStr = queryParams.get('excludePeople_list');
      const companyListIncludesStr = queryParams.get('company_list');
      const companyListExcludesStr = queryParams.get('excludeCompany_list');

      // Parse comma-separated values
      const parseListIds = (str: string | null): number[] => {
        if (!str) return [];
        return str
          .split(',')
          .map((id) => parseInt(id.replace(/"/g, '').trim(), 10))
          .filter((id) => !Number.isNaN(id) && id > 0);
      };

      // Prioritize people_list if present, otherwise use company_list
      const listIncludes = peopleListIncludesStr
        ? parseListIds(peopleListIncludesStr)
        : parseListIds(companyListIncludesStr);
      const listExcludes = peopleListExcludesStr
        ? parseListIds(peopleListExcludesStr)
        : parseListIds(companyListExcludesStr);

      if (listIncludes.length > 0 || listExcludes.length > 0) {
        filters.listIds = {
          includes: listIncludes,
          excludes: listExcludes,
        };
      }

      if (queryParams.get('excludeProspects') === 'true') {
        filters.excludeProspects = true;
      }
    } catch (error) {
      filters = initialFilters;
    }
    return filters;
  };

  const [savedFilters, setSavedFilters] = React.useState(handleDefaultValues());

  React.useEffect(() => {
    setSavedFilters(handleDefaultValues());
  }, [location.search]);

  const __handleDeleteSpecificValueFromQuery = ({ key, value }) => {
    // Handle comma-separated format (for list filters) or single value
    const paramValue = queryParams.get(key);
    if (!paramValue) return;

    // Check if it's comma-separated (list filters) or single value
    if (paramValue.includes(',')) {
      const paramValues = paramValue
        .split(',')
        .map((item) => item.replace(/"/g, '').trim());
      const updatedValues = paramValues.filter((v) => v !== value);

      queryParams.delete(key);
      if (updatedValues.length > 0) {
        queryParams.set(key, updatedValues.join(','));
      }
    } else if (paramValue.replace(/"/g, '') === value) {
      queryParams.delete(key);
    }
  };

  const handleGetAllKeysByFilterFromQuery = () => {
    const uniqueKeys = new Set();

    // Get tags from query params
    if (queryParams.has('tags')) {
      const tagIds = queryParams.get('tags')?.split(',') || [];
      tagIds.forEach((tagId) => {
        uniqueKeys.add({
          key: 'tags',
          value: parseInt(tagId, 10),
          label: `Tag ${tagId}`,
        });
      });
    }

    // Get date from query params
    if (queryParams.has('createdDate')) {
      const dateRange = queryParams.get('createdDate');
      uniqueKeys.add({
        key: 'createdDate',
        value: dateRange,
        label: dateRange,
      });
    }

    // Get list filters from query params (both people and company)
    const peopleListIncludesStr = queryParams.get('people_list');
    const peopleListExcludesStr = queryParams.get('excludePeople_list');
    const companyListIncludesStr = queryParams.get('company_list');
    const companyListExcludesStr = queryParams.get('excludeCompany_list');

    // Parse comma-separated values
    const parseListIds = (str: string | null): string[] => {
      if (!str) return [];
      return str.split(',').map((id) => id.replace(/"/g, '').trim());
    };

    parseListIds(peopleListIncludesStr).forEach((id) => {
      uniqueKeys.add({
        key: 'people_list',
        value: id,
        label: `List ${id}`,
        isExclude: false,
      });
    });
    parseListIds(peopleListExcludesStr).forEach((id) => {
      uniqueKeys.add({
        key: 'excludePeople_list',
        value: id,
        label: `List ${id}`,
        isExclude: true,
      });
    });
    parseListIds(companyListIncludesStr).forEach((id) => {
      uniqueKeys.add({
        key: 'company_list',
        value: id,
        label: `List ${id}`,
        isExclude: false,
      });
    });
    parseListIds(companyListExcludesStr).forEach((id) => {
      uniqueKeys.add({
        key: 'excludeCompany_list',
        value: id,
        label: `List ${id}`,
        isExclude: true,
      });
    });

    return uniqueKeys;
  };

  const handleIndividualTag = (tag: any) => {
    __handleDeleteSpecificValueFromQuery({ key: tag?.key, value: tag?.value });

    history.push({
      search: queryParams.toString(),
      hash: LeadFinderSecondaryTab.SAVED,
    });
  };

  const handleQuery = ({
    filterKey,
    filterValue,
    filterType,
    filterExcludeKey,
  }: {
    filterKey: string;
    filterValue: any;
    filterType: string;
    filterExcludeKey?: string;
  }) => {
    // eslint-disable-next-line default-case
    switch (filterType) {
      case FilterComponentType.SEARCH_INPUT:
        if (filterValue !== '') {
          queryParams.set(filterKey, [`${filterValue}`].toString());
        } else {
          queryParams.delete(filterKey);
        }
        break;
      case FilterComponentType.SAVED_LEAD_DATE:
        if (filterValue?.createdDate?.length) {
          const dateObjects = filterValue?.createdDate.map((e) => e.toString());
          queryParams.set(filterKey, `${dateObjects.join('-')}`);
        } else {
          queryParams.delete(filterKey);
        }
        break;
      case FilterComponentType.TAG_CHECKBOX:
        if (filterValue?.tags?.length > 0) {
          queryParams.set(filterKey, `${filterValue?.tags.join(',')}`);
        } else {
          queryParams.delete(filterKey);
        }
        break;
      case FilterComponentType.COMPANY_LIST:
        {
          const excludeKey = filterExcludeKey || 'excludeCompany_list';

          if (filterValue?.includedKeys?.length > 0) {
            const includedValues = filterValue.includedKeys
              .map((key: string) => key.replace(/"/g, ''))
              .join(',');
            queryParams.set(filterKey, includedValues);
          } else {
            queryParams.delete(filterKey);
          }

          if (filterValue?.excludedKeys?.length > 0) {
            const excludedValues = filterValue.excludedKeys
              .map((key: string) => key.replace(/"/g, ''))
              .join(',');
            queryParams.set(excludeKey, excludedValues);
          } else {
            queryParams.delete(excludeKey);
          }
        }
        break;
    }

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      history.push({
        search: queryParams.toString(),
        hash: LeadFinderSecondaryTab.SAVED,
      });
    }, 0);
  };

  const handleDeleteFilter = (filter) => {
    if (filter) {
      filter?.type.forEach((type) => {
        queryParams.delete(type?.key);
        queryParams.delete(type?.excludeKey);
      });
      history.push({
        search: queryParams.toString(),
        hash: LeadFinderSecondaryTab.SAVED,
      });
    }
  };

  const handleClearAllFilters = () => {
    history.push({
      search: '',
      hash: LeadFinderSecondaryTab.SAVED,
    });
  };

  const handleExcludeProspectsToggle = (value: boolean) => {
    if (value) {
      queryParams.set('excludeProspects', 'true');
    } else {
      queryParams.delete('excludeProspects');
    }
    history.push({
      search: queryParams.toString(),
      hash: LeadFinderSecondaryTab.SAVED,
    });
  };

  return {
    handleQuery,
    handleDeleteFilter,
    handleGetAllKeysByFilterFromQuery,
    handleIndividualTag,
    handleDefaultValues,
    handleClearAllFilters,
    handleExcludeProspectsToggle,
    savedFilters,
    setSavedFilters,
  };
};
